import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import * as serviceWorker from "./serviceWorker";
import { ThemeContext } from "./helpers/contexts.js";
import Theme from "components/style/themes";
import App from "App";
import { GTM_ID } from "constant";
import TagManager from "react-gtm-module";
import "css/style.css";

// if (document.getElementById("react-login")) {
//   ReactDOM.render(
//     React.createElement(Login, {}, null),
//     document.getElementById("react-login")
//   );
// }
// if (document.getElementById("react-partners")) {
//   ReactDOM.render(
//     React.createElement(SignUp, {}, null),
//     document.getElementById("react-partners")
//   );
// }
// if (document.getElementById("react-contact")) {
//   ReactDOM.render(
//     React.createElement(Contact, {}, null),
//     document.getElementById("react-contact")
//   );
// }
// if (document.getElementById("react-cookie")) {
//   ReactDOM.render(
//     React.createElement(CookiesFooter, { showBar: true }, null),
//     document.getElementById("react-cookie")
//   );
// }

TagManager.initialize({
  gtmId: GTM_ID,
});

ReactDOM.render(
  <ThemeContext.Provider value={Theme}>
    <App />
  </ThemeContext.Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
